export default "__VITE_ASSET__Du96HgX4__"